import React from 'react';

import { defineMessages, t } from '@sm/intl';

import ListingsBasePage from './ListingsBasePage';

const COPY = defineMessages({
  PAGE_TITLE: {
    id: 'Listings.Featured.Title',
    defaultMessage: 'Featured',
    description:
      '[Type: Header][Vis.: high] - The title of the page for the featured apps.'
  }
});

const Featured = () => {
  return (
    <ListingsBasePage
      pageId="App Directory - Featured"
      filter="FEATURED"
      title={t(COPY.PAGE_TITLE)}
      pageTitle="SurveyMonkey Featured Apps &amp; Integrations"
      description="Integrate SurveyMonkey Featured apps and plug-ins to get more done"
    />
  );
};

export default Featured;
